import { useWindowDimensions } from "react-native";

const BASE_WIDTH = 1400;

// Shared desktop-first → mobile scaling.
// IMPORTANT: We always base the visual scale on the "landscape" dimension
// (the larger of width/height) so that component/font sizes look the SAME
// in portrait and landscape on the same device, even if the user never
// rotates the device.
export function useRemScale() {
  // Be defensive: some environments/hooks mocking can return undefined
  const dims =
    (typeof useWindowDimensions === "function" ? useWindowDimensions() : {}) ||
    {};

  const rawWidth =
    typeof dims.width === "number" && dims.width > 0 ? dims.width : BASE_WIDTH;
  const rawHeight =
    typeof dims.height === "number" && dims.height > 0 ? dims.height : BASE_WIDTH;

  const referenceWidth = Math.max(rawWidth, rawHeight);

  const scale = Math.max(0.5, Math.min(1, referenceWidth / BASE_WIDTH));
  const rem = (value) => value * scale;

  return { rem, scale, BASE_WIDTH };
}
